<!-- @veltra/icons generated sha256:b76f08427c70282f gen:8 source:src/svg/normal/rotate-left.svg -->
<script setup lang="ts">
defineOptions({ name: 'RotateLeft' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M10.146 1.323 7.793 3.677l2.353 2.353.708-.707-1.147-1.146H11.5q.621 0 1.06.44.44.438.44 1.06v2h1v-2q0-1.036-.732-1.768T11.5 3.177H9.707l1.147-1.147zM2 13.677v-6q0-.099.02-.195.018-.097.056-.188.038-.09.093-.173.054-.082.124-.151.07-.07.151-.125.082-.054.173-.092t.188-.057.195-.02h7q.098 0 .195.02t.188.057.173.092.151.125.124.151q.055.082.093.173t.057.188.019.195v6q0 .098-.02.195-.018.096-.056.187t-.093.173-.124.152-.151.124-.173.093q-.091.037-.188.057-.097.019-.195.019H3q-.098 0-.195-.02-.097-.019-.188-.056-.09-.038-.173-.093-.081-.054-.151-.124t-.124-.152-.093-.173-.057-.187T2 13.677m1 0h7v-6H3z"
    />
  </svg>
</template>
